var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",staticClass:"inst-log layout",class:_vm.line(),attrs:{"log":_vm.log}},[(_vm.badge)?_c('span',{staticClass:"badge iconfont",class:_vm.badge,attrs:{"slot":"badge"},slot:"badge"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }